import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { DirectorResponseEditCommand } from "../../../../../services/varianceService/commands/DirectorResponseEditCommand";
import { useDirectorResponseEditMutation } from "../../../../../services/varianceService/variance-api";
import { toggleDirectorResponseEditModal } from "../../../../../app/slices/VarianceModuleSlice";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";

function DirectorResponseEditDialog() {
    const dispatch = useAppDispatch();
    const { data } = useMyProfileQuery();
    const modalOpen = useAppSelector((state) => state.varianceModule.DirectorResponseEditModal);
    const selectedResponse = useAppSelector((state) => state.varianceModule.SelectedDirectorResponseForEdit);
    const varianceId = useAppSelector((state) => state.varianceRequest.varianceRequest.id);
    const [text, setText] = React.useState("");
    const [editResponse] = useDirectorResponseEditMutation();

    React.useEffect(() => {
        if (selectedResponse) {
            setText(selectedResponse.text || "");
        }
    }, [selectedResponse]);

    const saveResponse = () => {
        if (selectedResponse) {
            let command = new DirectorResponseEditCommand(
                varianceId!,
                selectedResponse.directorResponseId,
                text,
                data!.identity!
            );
            editResponse(command);
        }
    };

    const handleClose = () => {
        dispatch(toggleDirectorResponseEditModal(null));
        setText("");
    };

    return (
        <Dialog open={modalOpen} onClose={handleClose}>
            <DialogTitle>Edit Director Response</DialogTitle>
            <DialogContent>
                <TextField
                    label="Response"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    multiline
                    fullWidth
                    sx={{ width: "500px", marginTop: "10px" }}
                    minRows={5}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={() => { saveResponse(); handleClose(); }}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}

export { DirectorResponseEditDialog };
